import React, {PropTypes} from 'react';

import LabelHover from './LabelHover';

class FilledLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
      hover: false
    };
  }

  componentWillReceiveProps(newProps) {
    if(newProps.canHover === false) {
      this.setState({hover: false});
    } 

    if(this.props.index === newProps.index) {
      this.setState({dragging: false});
    }
  }

  handleMouseDown = () => {
    this.setState({dragging: true});
  }

  handleMouseUp = () => {
    this.setState({dragging: false});
  }

  handleMouseEnter = () => {
    this.setState({hover: true});
  }

  handleMouseLeave = () => {
    this.setState({hover: false});
  }

  render() {
    const {canHover, imageUrl, index} = this.props;
    return (
      <div className="label-image" 
           style={{backgroundImage: 'url(' + imageUrl + ')'}} 
           onMouseEnter={this.handleMouseEnter} 
           onMouseOver={this.handleMouseEnter}
           onMouseUp={this.handleMouseUp}>
        {(this.state.hover && canHover && !this.state.dragging) && 
        <LabelHover index={index} onMouseDown={this.handleMouseDown} onMouseLeave={this.handleMouseLeave}/>}
      </div>
    );
  }
}

FilledLabel.propTypes = {
  canHover: PropTypes.bool.isRequired,
  imageUrl: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

export default FilledLabel;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/FilledLabel.js
 **/